module.exports = __webpack_public_path__ + "d8e376980a4ad5308f24955b705ec2d7.pdf";